import React, { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import ApiService from "../services/ApiService";

const UserRedirect = () => {
  const { currentUser, userProfile, loading } = useAuth();
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const handleUserRedirect = async () => {
      if (!loading && currentUser) {
        try {
          // Check if we already have user profile with role
          if (userProfile && userProfile.role) {
            await redirectBasedOnRoleAndStatus(userProfile.role);
          } else {
            // Fetch user profile to get role
            const profile = await ApiService.getUserProfile(currentUser.uid);
            const userData = profile.data || profile.user || profile;
            await redirectBasedOnRoleAndStatus(userData.role || "user");
          }
        } catch (error) {
          console.error("Error fetching user role:", error);
          // Default to user flow if error
          await redirectBasedOnRoleAndStatus("user");
        }
      } else if (!loading && !currentUser) {
        // Not authenticated, redirect to login
        navigate("/login");
      }
      setChecking(false);
    };

    const redirectBasedOnRoleAndStatus = async (role) => {
      if (role === "admin") {
        navigate("/admin-dashboard");
        return;
      }

      // For users, check onboarding status
      try {
        const statusResponse = await ApiService.getOnboardingStatus();
        const status = statusResponse.data;

        console.log("User onboarding status:", status);

        // Check the onboarding flow
        if (!status.termsAccepted) {
          console.log("Terms not accepted, redirecting to setup");
          navigate("/user-setup");
        } else if (!status.profileCompleted) {
          console.log("Profile not completed, redirecting to setup");
          navigate("/user-setup");
        } else if (status.credits === 0 && !status.hasActiveSubscription) {
          console.log("Needs subscription, redirecting to setup");
          navigate("/user-setup?step=subscription");
        } else {
          console.log("User fully set up, redirecting to dashboard");
          navigate("/user-dashboard");
        }
      } catch (onboardingError) {
        console.error("Error checking onboarding status:", onboardingError);
        // Default to setup page if can't determine status
        navigate("/user-setup");
      }
    };

    handleUserRedirect();
  }, [currentUser, userProfile, loading, navigate]);

  // Show loading while checking authentication and role
  if (loading || checking) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          color: "#ffffff",
          fontSize: "18px",
          fontWeight: "500",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          <div
            style={{
              width: "40px",
              height: "40px",
              border: "3px solid rgba(255, 255, 255, 0.3)",
              borderTop: "3px solid #ffffff",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
            }}
          ></div>
          <div>Redirecting to your dashboard...</div>
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      </div>
    );
  }

  return null;
};

export default UserRedirect;
